export const AUTH_REQUEST = 'AUTH_REQUEST'
export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const AUTH_ERROR = 'AUTH_ERROR'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
// /* global localStorage */

// import User from '@/models/User'
// import * as MutationTypes from './mutation-types'

// const state = {
//   user: User.from(localStorage.token)
// }

// const mutations = {
//   [MutationTypes.LOGIN] (state) {
//     state.user = User.from(localStorage.token)
//   },
//   [MutationTypes.LOGOUT] (state) {
//     state.user = null
//   }
// }

// const getters = {
//   currentUser (state) {
//     return state.user
//   }
// }

// const actions = {
//   login ({ commit }) {
//     commit(MutationTypes.LOGIN)
//   },

//   logout ({ commit }) {
//     commit(MutationTypes.LOGOUT)
//   }
// }

// export default {
//   state,
//   mutations,
//   getters,
//   actions
// }



// WEBPACK FOOTER //
// ./src/store/actions/auth.js